export { QrModal } from "./QrModal";
